// extracted by mini-css-extract-plugin
module.exports = {"page":"NewPassword_page__26CVd","form":"NewPassword_form__WnsNo","paragraph":"NewPassword_paragraph__4XbO-","text":"NewPassword_text__33PdW"};